<div class="container">
  <div class="logo">
    <img src="/assets/icons/b2a_logo_transparent.png" alt="" *ngIf="type === userSite" />
  </div>

  <div class="innerContainer">
    <nav>
      <ul>
        <li>
          <a routerLink="/imprint">{{ 'NAVIGATION.navImprint' | translate }}</a>
        </li>
        <li>
          <a routerLink="/tos">{{ 'NAVIGATION.navToS' | translate }}</a>
        </li>
        <li>
          <a routerLink="/privacy">{{ 'NAVIGATION.navPrivacy' | translate }}</a>
        </li>
        <li>
          <a routerLink="/copyright">{{ 'NAVIGATION.navCopyright' | translate }}</a>
        </li>
      </ul>
    </nav>
    <p class="copyright">&copy; {{ currentYear }} Back2Action GmbH</p>
  </div>

  <div class="placeholder"></div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/footer/footer.component.html